export default __webpack_public_path__ + "3ed9ced78d923e424d2d5f44d25255a7.jpg";